import React, { useState } from 'react';

interface MarkdownImageProps {
    src?: string;
    alt?: string;
    onClick: (src: string) => void;
}

const MarkdownImage: React.FC<MarkdownImageProps> = ({ src, alt, onClick }) => {
    const [imageError, setImageError] = useState(false);

    const handleImageError = () => {
        setImageError(true);
    };

    // Don't render anything if image failed to load or src is missing
    if (imageError || !src) {
        return null;
    }

    return (
        <button
            className="cursor-pointer block w-full"
            onClick={() => onClick(src)}
        >
            <div className="flex justify-center items-center">
                <img
                    src={src}
                    alt={alt || "Inline image"}
                    className="my-1 p-1 max-w-full max-h-[50vh] h-auto object-contain bg-black cursor-pointer rounded-lg pointer-events-auto"
                    onError={handleImageError}
                />
            </div>
        </button>
    );
};

export default MarkdownImage;